import { useState, useEffect } from "react";
import axios from 'axios';
import { FaTrash } from "react-icons/fa"; // Import bin icon
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}


const Organization = () => {
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const [newOrgName, setNewOrgName] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [organizations, setOrganization] = useState([]);

  const [token, setToken] = useState(getCookie("accessToken"))

  const navigate = useNavigate();

  useEffect(() => {
    
    setToken(getCookie("accessToken"))
    if (!token) {
      navigate("/"); // Redirect to home page

    }

      axios.get('https://onehum-backend.acuitas360.com/organization', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then(response => {
          setOrganization(response.data);
          // console.log(organizations)
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }, [successMessage]);

  const handleNewSubmit = async (e) => {
    e.preventDefault();
    const newOrg = { name: newOrgName, logo: logoUrl, module: [], user: [] };

    try {
      // Make POST request using Axios
      const response = await axios.post("https://onehum-backend.acuitas360.com/organization", newOrg, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.status === 201) {
        setSuccessMessage("New organization created successfully!");
        setTimeout(() => {
          setShowNewForm(false); // Hide form
          setSuccessMessage(""); // Clear success message
          setSelectedOrg(null); // Clear selection
        }, 2000); // Show message for 2 seconds
      }
    } catch (error) {
      alert("Failed to add new organization");
    }
  };

  return (
    <div className="p-4 bg-gray-100 rounded">
      {/* Conditionally render select dropdown or form */}


      {/* Success Message */}
      {successMessage && (
        <div className="mt-4 p-2 bg-green-500 text-white rounded">
          {successMessage}
        </div>
      )}

      {/* New Organization Form */}
      {showNewForm && (
        <form onSubmit={handleNewSubmit} className="mt-4 p-4 bg-white shadow-md rounded">
          <h3 className="text-lg font-medium mb-2">Add New Organization</h3>
          <label className="block mb-2">Organization Name</label>
          <input
            type="text"
            value={newOrgName}
            onChange={(e) => setNewOrgName(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          />
          <label className="block mb-2">Logo URL</label>
          <input
            type="text"
            value={logoUrl}
            onChange={(e) => setLogoUrl(e.target.value)}
            className="w-full p-2 border rounded mb-4"
            required
          />
          <div className="flex justify-between">
            <button type="submit" className="px-4 py-2 bg-green-500 text-white rounded">
              Submit
            </button>
            <button
              type="button"
              onClick={() => {
                setShowNewForm(false);
                setSelectedOrg(null);
              }}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            >
              Back
            </button>
          </div>
        </form>
      )}

      {/* Selected Organization Display */}
      {organizations.length > 0 && (
        <div className="bg-white p-4 rounded shadow-md mt-4">
          <h3 className="text-lg font-semibold mb-4 text-center">All Organizations</h3>
          <ul className="divide-y divide-gray-300">
            {organizations.map((user) => (

              <li key={user.id} className="flex items-center justify-between p-3 bg-gray-200 hover:bg-gray-300 rounded-md transition">
                <div className="flex items-center gap-5 w-full">

                  {/* Logo Section */}
                  <div className="w-1/4 h-24 flex items-center justify-center">
                    <img src={user.logo} alt={user.name} className="max-w-44 max-h-24 object-contain" />
                  </div>

                  {/* Name Section */}
                  <div className="w-1/5 flex justify-center">
                    <p className="font-medium text-xl text-center"><strong>{user.name}</strong></p>
                  </div>

                  {/* Stats Section */}
                  <div className="w-1/5 flex flex-col justify-center">
                    <p>Total Users: <strong className="font-medium">{user.user.length}</strong></p>
                    <p>Total Modules: <strong className="font-medium">{user.module.length}</strong></p>
                  </div>

                </div>
              </li>

            ))}
          </ul>
        </div>
      )}

      {/* New and Edit Buttons */}
      {!showNewForm && (
        <div className="mt-4 flex space-x-4">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded"
            onClick={() => setShowNewForm(true)}
          >
            New Organization
          </button>
          {/* <button
            className={`px-4 py-2 border-2 rounded transition-colors duration-300 ${
              !selectedOrg ? "bg-gray-300 text-gray-500" : "bg-gray-500 text-white"
            }`}
            disabled={!selectedOrg}
          >
            Edit
          </button> */}
        </div>
      )}
    </div>
  );
};

export default Organization;